import { render, staticRenderFns } from "./FixedDigit.vue?vue&type=template&id=bafe5ba8&scoped=true"
import script from "./FixedDigit.vue?vue&type=script&lang=js"
export * from "./FixedDigit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafe5ba8",
  null
  
)

export default component.exports